//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'DukeCriteria_info',
  data() {
    return {}
  },
  components: {},
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/ID/DukeCriteria_info.vue